import { SET_EDITED_CARD } from '../actions/types'

const initialState = {
  items: [],
  justEdited: null,
  isFetching: true,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_EDITED_CARD:
      return {
        ...state,
        justEdited: action.payload,
      }

    default:
      return state
  }
}
